<div class="dialog">
  <h2>⚠ Force Delete Station</h2>

  <p class="message">
    Deleting {{ data.stationName }} will permanently remove all associated data. This cannot be undone.
  </p>

  <div class="deletion-items-list">
    <p class="deletion-items-heading">The following will be deleted:</p>
    <ul>
      <li *ngFor="let item of items">{{ item.count }} {{ item.label }}</li>
    </ul>
  </div>

  <div class="force-delete-warning">
    This action is permanent and cannot be reversed.
  </div>

  <label class="confirm-input-label" for="confirm-station-name">
    Type the station name to confirm deletion:
  </label>
  <input
    id="confirm-station-name"
    class="confirm-station-input"
    type="text"
    [placeholder]="data.stationName"
    [(ngModel)]="confirmName"
    autocomplete="off"
    (keydown.enter)="confirm()"
  />

  <div class="actions">
    <button type="button" class="btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn-danger" [disabled]="!canConfirm" (click)="confirm()">
      Delete Everything
    </button>
  </div>
</div>
